import { useMutation, useQueryClient } from "@tanstack/react-query";
import { App } from "antd";
import { usePaginatedQuery } from "@/shared/hooks/usePaginatedQuery";
import { getErrorMessage } from "@/shared/utils/getErrorMessage";
import { devicesService } from "../services/devices.service";
import type { Device } from "../types";

export function useDevicesList() {
	return usePaginatedQuery<Device>({
		queryKey: ["devices"],
		url: "/devices",
	});
}

/**
 * ⚠️ Uchala kalit ham invalidatsiya qilinadi — `["devices"]`
 * (`DevicesPage`), `["employees", "tab", "devices"]` (`EmployeeDevicesTab`,
 * shu tugma joylashgan jadvalning O'ZI) va `["employees", "device"]`
 * (`useEmployeeDevice` — profil sarlavhasidagi "Qurilma" fakti,
 * `EmployeeFactsRow.tsx`). Oxirgisi eng jimgina unutiladigani: u
 * boshqacha kalit ostida FAQAT amaldagi qurilmani so'raydi, shuning
 * uchun uni tashlab ketish sarlavhani deaktivatsiyadan keyin ham "Faol"
 * ko'rsatib qoldiradi.
 */
export function useDeactivateDevice() {
	const { message } = App.useApp();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => devicesService.deactivate(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["devices"] });
			queryClient.invalidateQueries({ queryKey: ["employees", "tab", "devices"] });
			queryClient.invalidateQueries({ queryKey: ["employees", "device"] });
			message.success("Qurilma bekor qilindi");
		},
		onError: (error) => {
			message.error(getErrorMessage(error, "Amalni bajarib bo'lmadi"));
		},
	});
}

/**
 * Admin panelidan ONGLI faollashtirish — mobil `register` oqimidagi
 * avtomatik eskisini-o'chirish bu yerga KO'CHIRILMAYDI (P3 spec §5):
 * limitga urilsa backend `conflict` bilan rad etadi, xabari
 * `getErrorMessage` orqali chiqadi.
 */
export function useActivateDevice() {
	const { message } = App.useApp();
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: (id: string) => devicesService.activate(id),
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ["devices"] });
			queryClient.invalidateQueries({ queryKey: ["employees", "tab", "devices"] });
			queryClient.invalidateQueries({ queryKey: ["employees", "device"] });
			message.success("Qurilma faollashtirildi");
		},
		onError: (error) => {
			message.error(getErrorMessage(error, "Amalni bajarib bo'lmadi"));
		},
	});
}
